export default {
  set(state, { token, authenticated }) {
    state.authenticated = authenticated;
    state.token = token;
  },
  profile(state, {admin, imach, maintainer, vm, company, parent_company}) {
    state.admin = admin
    state.imach = imach
    state.maintainer = maintainer
    state.vm = vm
    state.company = company
    state.parent_company = parent_company
  }
}